import moment from 'moment'
import meta from '@/config/meta'
import { join } from 'path'

const units = {
  cert: {
    '英検': '級',
    'TOEIC': '点',
    'TOEFL': '点',
    'TOEFL iBT': '点',
    'IELTS': '点'
  }
}
export default {
  publish: (form) => {
    const { office, backgrounds } = form || {}
    const {
      smoke, hobby, allergy, religion, kids, pets, notes,
      passports, visas, travels, langs, certs, careers, medicals
    } = backgrounds || {}
    const { about, nations } = meta
    const passport = (passports && passports.length) ? passports[0] : {
      status: '', number: '', publish: '', expire: ''
    }
    const currentVisa = visas.filter(it => { return it.status !== 'DONE' }).pop() || {
      arranger: '', country: '', expire: '', publish: '', status: '', type: ''
    }
    const pastVisas = visas.filter(it => { return it.status === 'DONE' })
    const officeIdx = Object.keys(meta.offices).findIndex(key => { return meta.offices[key].slug === office })
    const officeId = Object.keys(meta.offices)[officeIdx >= 0 ? officeIdx : 0]

    console.log(form)
    // let phones = (bs.contacts && bs.contacts.length) ? bs.contacts.filter(it => { return (it.type && it.type === 'phone') }) : [{}]
    // let mobiles = (bs.contacts && bs.contacts.length) ? bs.contacts.filter(it => { return (it.type && it.type === 'mobile') }) : [{}]
    // let emails = (bs.contacts && bs.contacts.length) ? bs.contacts.filter(it => { return (it.type && it.type === 'email') }) : [{}]
    return {
      pageSize: 'A4',
      pageMargins: [40, 100, 40, 100],
      header: [
        {
          text: '申し込み内容補足情報シート',
          style: 'title'
        },
        {
          text: (meta.offices[officeId].document.header) + '宛',
          style: 'header'
        }
      ],
      footer: [
        {
          margin: [40, 0, 40, 0],
          table: {
            widths: ['*'],
            heights: [30],
            body: [
              [
                {
                  border: [true, true, true, true],
                  table: {
                    widths: ['*', 120, 20, 150],
                    body: [
                      [
                        {
                          border: [false, false, false, false],
                          text: '　'
                        },
                        {
                          border: [false, false, false, false],
                          text: '上記について、事実に相違ありません。',
                          fontSize: 6,
                          alignment: 'right',
                          margin: [0, 2, 0, 0]
                        },
                        {
                          border: [false, false, false, false],
                          text: '（署名）',
                          fontSize: 6,
                          alignment: 'right',
                          margin: [0, 10, 0, 0]
                        },
                        {
                          border: [false, false, false, true],
                          text: '　',
                          margin: [0, 8, 0, 0]
                        }
                      ]
                    ]
                  }
                }
              ]
            ]
          }
        }
      ],
      content: [
        {
          table: {
            widths: ['*'],
            heights: ['auto', 'auto', 'auto', 'auto', 'auto', 'auto', 220, 'auto'],
            body: [
              [
                {
                  border: [true, true, true, false],
                  text: '■ホームステイ申し込みに際し必要な情報',
                  style: 'section'
                }
              ],
              [
                {
                  border: [true, false, true, false],
                  text: '滞在先手配のための参考情報となります。ただし、必ずしも希望通りの滞在先をご紹介できるとは限りません。ご了承ください。',
                  style: 'plain',
                  margin: [5, 2, 0, 5]
                }
              ],
              [
                {
                  border: [true, false, true, false],
                  columns: [
                    [
                      [
                        {
                          border: [false, false, false, false],
                          text: '1. たばこを吸いますか？',
                          style: 'question'
                        },
                        {
                          border: [false, false, false, false],
                          text: `${smoke ? smoke.status : ''}`,
                          style: 'answer'
                        }
                      ],
                      [
                        {
                          border: [false, false, false, false],
                          text: '2. 趣味・特技は何ですか？',
                          style: 'question'
                        },
                        {
                          border: [false, false, false, false],
                          text: `${hobby ? hobby.note : ''}`,
                          style: 'answer'
                        }
                      ],
                      [
                        {
                          border: [false, false, false, false],
                          text: '3. 滞在先家庭の子供について、苦手な年代はありますか？',
                          style: 'question'
                        },
                        {
                          border: [false, false, false, false],
                          text: `${(kids && kids.content) ? kids.content.replace(',', '、') : ''}`,
                          style: 'answer'
                        }
                      ],
                      [
                        {
                          border: [false, false, false, false],
                          text: '4. アレルギー（食物を含む）はありますか？',
                          style: 'question'
                        },
                        {
                          border: [false, false, false, false],
                          text: `${allergy.status}${allergy.note ? '：' : ''}${allergy.note}`,
                          style: 'answer'
                        }
                      ]
                    ],
                    [
                      [
                        {
                          border: [false, false, false, false],
                          text: '5. ペットが家の中にいてもいいですか？',
                          style: 'question'
                        },
                        {
                          border: [false, false, false, false],
                          text: `${pets.status}${pets.note ? '：' : ''}${pets.note}`,
                          style: 'answer'
                        }
                      ],
                      [
                        {
                          border: [false, false, false, false],
                          text: '6. 特に信仰している宗教はありますか？',
                          style: 'question'
                        },
                        {
                          border: [false, false, false, false],
                          text: `${religion.status}${religion.name ? '：' : ''}${religion.name}`,
                          style: 'answer'
                        }
                      ],
                      [
                        {
                          border: [false, false, false, false],
                          text: '7. その他、ご要望',
                          style: 'question'
                        },
                        {
                          border: [false, false, false, false],
                          text: `${notes.note}`,
                          style: 'answer'
                        }
                      ]
                    ]
                  ]
                }
              ],
              [
                {
                  border: [true, false, true, false],
                  text: '■その他必要情報',
                  style: 'section',
                  margin: [5, 30, 0, 0]
                }
              ],
              [
                {
                  border: [true, false, true, false],
                  columns: [
                    [
                      [
                        {
                          text: '【現在有効なパスポート情報】',
                          style: 'question'
                        },
                        {
                          text: `${about.passport.status[passport.status] || ''}${passport.number ? '：' : ''}${passport.number}`,
                          style: 'answer'
                        },
                        {
                          text: `有効期限：${passport.publish ? moment(passport.publish).format('YYYY年MM月DD日') : ''}〜${passport.expire ? moment(passport.expire).format('YYYY年MM月DD日') : ''}`,
                          style: 'answer',
                          fontSize: 7,
                          margin: [5, 5, 0, 0],
                        }
                      ],
                      [
                        {
                          text: '【留学に必要なビザ】',
                          style: 'question'
                        },
                        {
                          text: `${about.visa.status[currentVisa.status] || ''}：${about.visa.types[currentVisa.type] || about.visa.arrangers[currentVisa.arranger] || ''}`,
                          style: 'answer'
                        },
                        {
                          text: [
                            '　',
                            ...(nations[currentVisa.country] ? [ `発行国：${nations[currentVisa.country]}` ] : []),
                            ...((currentVisa.publish || currentVisa.expire) ? [ `有効期限：${currentVisa.publish ? moment(currentVisa.publish).format('YYYY年MM月DD日') : ''}〜${currentVisa.expire ? moment(currentVisa.expire).format('YYYY年MM月DD日') : ''}` ] : [])
                          ].join('\n'),
                          style: 'answer',
                          fontSize: 7,
                          margin: [5, 5, 0, 0],
                        }
                      ],
                      [
                        {
                          text: '【過去に取得したビザ】',
                          style: 'question'
                        },
                        ...pastVisas.map(it => {
                          return [
                            {
                              text: about.visa.types[it.type] || '',
                              style: 'answer'
                            },
                            {
                              text: [
                                `発行国：${nations[it.country] || ''}`,
                                `発行日：${it.publish ? moment(it.publish).format('YYYY年MM月DD日') : ''}`
                              ].join('\n'),
                              style: 'answer',
                              fontSize: 7,
                              margin: [5, 5, 0, 0]
                            }
                          ]
                        })
                      ]
                    ],
                    [
                      [
                        {
                          text: '【海外への渡航歴】',
                          style: 'question'
                        },
                        ...((travels && travels.length) ? travels.map(it => {
                          return [
                            {
                              text: nations[it.country] || '',
                              style: 'answer'
                            },
                            {
                              text: `${it.city || ''}${about.visa.types[it.type || ''] ? '：' : ''}${about.visa.types[it.type]}`,
                              style: 'answer',
                              fontSize: 7
                            },
                            {
                              text: `渡航年月日：${it.depart ? (moment(it.depart).isValid() ? moment(it.depart).format('YYYY年MM月DD日') : it.depart) : ''}${it.term ? '〜' : ''}${it.term}`,
                              style: 'answer',
                              fontSize: 7,
                              margin: [5, 0, 0, 5]
                            }
                          ]
                        }) : [])
                      ],
                      [
                        {
                          text: '【語学力（自己申告）】',
                          style: 'question'
                        },
                        ...langs.map(it => {
                          return {
                            text: `${about.langs[it.lang] || ''}${it.level ? '：' : ''}${it.level}`,
                            style: 'answer',
                            fontSize: 10
                          }
                        }),
                        {
                          text: '【語学資格】',
                          style: 'question'
                        },
                        ...certs.map(it => {
                          return {
                            text: `${it.name}：${it.score}${units.cert[it.name] || ''}`,
                            style: 'answer'
                          }
                        })
                      ]
                    ],
                    [
                      [
                        {
                          text: '【修了・在学中の学校】',
                          style: 'question'
                        },
                        ...careers.map(it => {
                          return [
                            {
                              text: it.name,
                              style: 'answer'
                            },
                            it.dept ? {
                              text: [
                                `専攻：${it.dept}`,
                                `${about.career.status[it.status] || ''}：${it.date ? moment(it.date).format('YYYY年MM月DD日') : ''}`
                              ].join('\n'),
                              style: 'answer',
                              fontSize: 7,
                              margin: [5, 0, 0, 5]
                            } : {
                              text: `${about.career.status[it.status] || ''}：${it.date ? moment(it.date).format('YYYY年MM月DD日') : ''}`,
                              style: 'answer',
                              fontSize: 7,
                              margin: [5, 0, 0, 5]
                            }
                          ]
                        })
                      ]
                    ]
                  ]
                }
              ],
              [
                [
                  {
                    border: [true, false, true, false],
                    text: '（重要）',
                    fontSize: 6,
                    bold: true,
                    margin: [5, 5, 0, 0]
                  },
                  {
                    border: [true, false, true, false],
                    text: '現在または過去において、呼吸器性疾患、精神・神経性疾患および心臓病などの重症病にかかり、医師の治療または投薬を受けたことがありますか？',
                    fontSize: 6,
                    margin: [5, 2, 0, 0]
                  },
                  ...medicals.map(it => {
                    return {
                      border: [true, false, true, true],
                      text: `${about.medical.status[it.status] || ''}：${it.name}`,
                      fontSize: 8,
                      margin: [5, 5, 5, 5],
                      alignment: 'right'
                    }
                  })
                ]
              ]
            ]
          }
        }
      ],
      styles: {
        title: {
          fontSize: 18,
          bold: true,
          alignment: 'center',
          margin: [0, 40, 0, 10]
        },
        header: {
          fontSize: 13,
          margin: [40, 0, 40, 0]
        },
        subheader: {
          fontSize: 6.5,
          margin: [40, 0, 40, 0]
        },
        footerNote: {
          fontSize: 6.5,
          margin: [5, 5, 5, 0]
        },
        section: {
          fontSize: 11,
          bold: true,
          margin: [5, 5, 0, 0]
        },
        subsection: {
          fontSize: 10,
          alignment: 'center',
          bold: true,
          margin: [0, 2, 0, 0]
        },
        plain: {
          fontSize: 9,
          margin: [5, 2, 0, 2]
        },
        question: {
          fontSize: 10,
          bold: true,
          margin: [5, 10, 0, 2]
        },
        answer: {
          fontSize: 11,
          margin: [5, 2, 0, 0],
          lineHeight: 1.2
        },
        sectionTitle: {
          fontSize: 8,
          lineHeight: 1.2
        },
        sectionSubTitle: {
          fontSize: 6,
          lineHeight: 1.2
        },
        signature: {
          fontSize: 6,
          alignment: 'center',
          margin: [0, 3, 0, 0]
        },
        companyName: {
          fontSize: 10,
          lineHeight: 1.5,
          bold: true
        }
      },
      defaultStyle: {
        font: 'AozoraMincho'
      }
    }
  }
}

